/* eslint-disable */
// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { EMPTY_ARRAY } from '../../constants/globalConstants'
// import play from '../../assets/img/play.png'
// import ios from '../../assets/img/ios.png'
import appstore from '../../assets/img/app-store.svg'
import playstore from '../../assets/img/google-play.svg'
import { getMobileOS } from '../../utils/helper'

function DownloadApp(props) {
    const { appUrls, setIsDisplayBanner } = props
    const [isDisplayDownload, setIsDisplayDownload] = useState(false)
    const [os, setOs] = useState('Other')

    useEffect(() => {
        setIsDisplayDownload(true)
        setIsDisplayBanner(true)
        const os = getMobileOS()
        setOs(os)
    }, [EMPTY_ARRAY])

    const handleHideDownload = () => {
        setIsDisplayDownload(false)
        setIsDisplayBanner(false)
    }

    const iosAppUrl = appUrls.filter((item) => item?.provider?.slug?.trim() == 'app-store')

    const androidAppUrl = appUrls.filter((item) => item?.provider?.slug?.trim() == 'google-play-store')
    return (
        isDisplayDownload && <div className='zIndex styleLables position-fixed bottom-0 bg-black w-100 text-white p-2 '>
            <i className="fa fa-close text-white position-absolute end-0 iconClose" onClick={() => handleHideDownload()}></i>
            <div className='p-2 g-0 row justify-content-between align-items-center'>
                <div className='col-8'>{(os == 'Android' || os == 'Other') ? androidAppUrl[0]?.title || 'Park here often? Download the app!' : iosAppUrl[0]?.title || 'Park here often? Download the app!'}</div>
                <div className='col text-end'>
                    {(os == 'Android' || os == 'Other') && androidAppUrl && androidAppUrl[0]?.store_url && <a className={os == 'Other' ? 'me-4' : ''} href={androidAppUrl[0]?.store_url} rel='noreferrer' target="_blank">
                        <img height={'40px'} src={playstore} alt={androidAppUrl[0]?.provider?.name} />
                    </a>}
                    {(os == 'iOS' || os == 'Other') && iosAppUrl && iosAppUrl[0]?.store_url && <a href={iosAppUrl[0]?.store_url} rel='noreferrer' target="_blank">
                        <img height={'40px'} src={appstore} alt={iosAppUrl[0]?.provider?.name} />
                    </a>}
                </div>
            </div>

        </div>
    )
}

DownloadApp.propTypes = {
    dispatch: PropTypes.func,
    appUrls: PropTypes.array,
    setIsDisplayBanner: PropTypes.func
}

DownloadApp.defaulProps = {
    dispatch: noop,
    appUrls: EMPTY_ARRAY,
    setIsDisplayBanner: noop
}


export default DownloadApp